import {
  actions as authActions,
  operations as authOperations,
  utils as authUtils,
} from '@saucelabs/sl-container-authentication';
import { actions as permissionsActions } from '@saucelabs/sl-container-permissions';
import { actions as userConcurrencyActions } from '@saucelabs/sl-module-concurrency';
import { actions as userTunnelsActions } from '@saucelabs/sl-module-tunnels';
import { actions as messagesActions } from '@saucelabs/sl-module-messages';
import Sentry from '@saucelabs/sl-util-sentry';
import { CURRENT_DC } from '@saucelabs/sl-util-config';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';

import * as actions from './actions';
import * as constants from './constants';

const updateLastUsedDataCenter = (payload) => (dispatch) => {
  if (payload?.dcName) {
    // used by ForgeRock AM to find out to which DC user should be redirected
    cookiesHelper.setItem(constants.LAST_USED_DC, payload.dcName);
  }
  dispatch(actions.updateLastUsedDC(payload));
};

const authenticate = async (dispatch, getState) => {
  try {
    // needed for oTM users to fetch the currently logged in user data
    await dispatch(authActions.getWhoami(null, { skipErrorPage: [401] }));
    await dispatch(authActions.getMeUserService());

    const { user } = getState();
    const username = user.get('username');

    if (user.isAuthenticated()) {
      Sentry.setUser({ username });
    }

    dispatch(updateLastUsedDataCenter({ dcName: CURRENT_DC }));
    authUtils.setLogoutUrl(user?.organization?.settings?.logout_url);
  } finally {
    await dispatch(actions.initialized());
  }
};

/*
Tries to fetch current user credentials while displaying loading state
in the whole UI, might be extended with other initial data requests
required for application to start.
*/
export const initialize = () => async (dispatch, getState) => {
  try {
    // refresh JWT and gives sl-auth cookie
    await dispatch(authActions.authenticateAM({}, { skipErrorPage: true }));
    await dispatch(authOperations.startCheckTimeToLogout());
  } finally {
    await authenticate(dispatch, getState);
  }
};

// Requests not critical for the initial UI load
export const postInitialize = () => (dispatch, getState) => {
  const { user } = getState();
  const username = user.get('username');

  dispatch(userConcurrencyActions.subscribeUser(username));
  dispatch(userConcurrencyActions.subscribeConcurrencies());
  dispatch(userTunnelsActions.subscribeUser(username));
  dispatch(userTunnelsActions.subscribeTunnels());

  // requests needed only for sauce-admin users
  dispatch(permissionsActions.getPermissions());
  dispatch(messagesActions.getMessages());
};

export const stop = () => (dispatch) => {
  dispatch(userConcurrencyActions.unsubscribeConcurrencies());
  dispatch(userTunnelsActions.unsubscribeTunnels());
  dispatch(actions.cleanup());
};
